<div class="container mx-auto p-6 max-w-6xl">
  <h2 class="text-center text-gray-800 mb-8 text-3xl font-bold">Seznam tekmovanj</h2>

  <div class="text-center my-8 text-lg text-gray-600 bg-blue-50 p-4 rounded-lg" *ngIf="loading">
    <i class="fas fa-spinner fa-spin mr-2"></i>Nalagam...
  </div>
  <div class="text-red-800 bg-red-100 border border-red-300 px-6 py-4 rounded-lg mb-6 text-center shadow-sm" *ngIf="error">
    <i class="fas fa-exclamation-triangle mr-2"></i>{{ error }}
  </div>

  <div class="mb-6 flex justify-between items-center">
    <button class="bg-blue-500 text-white border-none rounded-lg px-6 py-3 cursor-pointer text-base font-semibold transition-all hover:bg-blue-600 hover:shadow-lg transform hover:-translate-y-0.5 shadow-md" (click)="showAddDialog = true">
      <i class="fas fa-plus mr-2"></i>Dodaj tekmovanje
    </button>
    <div class="text-sm text-gray-500">
      Skupaj: {{ competitions.length || 0 }} tekmovanj
    </div>
  </div>

<ng-container *ngIf="showAddDialog">
  <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 backdrop-blur-sm">
    <app-tekme-add-dialog (save)="onAdd($event)" (cancel)="showAddDialog = false"></app-tekme-add-dialog>
  </div>
</ng-container>

<ng-container *ngIf="showEditDialog">
  <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 backdrop-blur-sm">
    <app-tekme-add-dialog
      [competition]="editCompetition"
      [isEditMode]="true"
      (save)="onEditSave($event)"
      (cancel)="showEditDialog = false">
    </app-tekme-add-dialog>
  </div>
</ng-container>

  <div class="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200" *ngIf="!loading && competitions.length > 0">
    <table class="w-full border-collapse">
      <thead>
        <tr class="bg-gradient-to-r from-blue-500 to-blue-600">
          <th class="px-6 py-4 text-left text-white font-bold text-sm uppercase tracking-wider">
            <i class="fas fa-hashtag mr-2"></i>ID
          </th>
          <th class="px-6 py-4 text-left text-white font-bold text-sm uppercase tracking-wider">
            <i class="fas fa-trophy mr-2"></i>Ime tekmovanja
          </th>
          <th class="px-6 py-4 text-left text-white font-bold text-sm uppercase tracking-wider">
            <i class="fas fa-calendar-alt mr-2"></i>Datum
          </th>
          <th class="px-6 py-4 text-left text-white font-bold text-sm uppercase tracking-wider">Teiler</th>
          <th class="px-6 py-4 text-left text-white font-bold text-sm uppercase tracking-wider">
            <i class="fas fa-cogs mr-2"></i>Akcije
          </th>
        </tr>
      </thead>
      <tbody class="divide-y divide-gray-200">
        <tr class="hover:bg-blue-50 transition-colors duration-200" *ngFor="let c of competitions; let i = index">
          <td class="px-6 py-4 text-sm font-medium text-gray-900">{{ c.competitionId }}</td>
          <td class="px-6 py-4 text-sm text-gray-700 font-medium">{{ c.competition_name }}</td>
          <td class="px-6 py-4 text-sm text-gray-600">
            <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
              {{ c.competition_date | date:'dd.MM.yyyy' }}
            </span>
          </td>
          <td class="px-6 py-4 text-sm text-gray-700">
            <i
              [class]="isTeilerCompetition(c) ? 'fas fa-check text-green-600' : 'fas fa-times text-red-600'"
              [attr.title]="isTeilerCompetition(c) ? 'Teiler tekmovanje' : 'Običajno tekmovanje'"
              [attr.aria-label]="isTeilerCompetition(c) ? 'Teiler tekmovanje' : 'Običajno tekmovanje'"></i>
          </td>
          <td class="px-6 py-4 text-sm">
            <div class="flex gap-3">
              <button class="bg-blue-500 text-white border-none rounded-lg px-4 py-2 cursor-pointer text-sm font-medium transition-all hover:bg-blue-600 hover:shadow-md transform hover:-translate-y-0.5" (click)="onEdit(c)">
                <i class="fas fa-edit mr-1"></i>Uredi
              </button>
              <button class="bg-green-500 text-white border-none rounded-lg px-4 py-2 cursor-pointer text-sm font-medium transition-all hover:bg-green-600 hover:shadow-md transform hover:-translate-y-0.5" [routerLink]="['/rezultati-tekem', c.competitionId]">
                <i class="fas fa-chart-bar mr-1"></i>Rezultati
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="text-center my-12 bg-gray-50 p-8 rounded-xl border-2 border-dashed border-gray-300" *ngIf="!loading && competitions.length === 0">
    <i class="fas fa-trophy text-gray-400 text-4xl mb-4"></i>
    <h3 class="text-xl font-semibold text-gray-600 mb-2">Ni tekmovanj</h3>
    <p class="text-gray-500 mb-4">Dodajte prvo tekmovanje, da začnete</p>
    <button class="bg-blue-500 text-white border-none rounded-lg px-6 py-3 cursor-pointer text-base font-semibold transition-all hover:bg-blue-600 hover:shadow-lg transform hover:-translate-y-0.5" (click)="showAddDialog = true">
      <i class="fas fa-plus mr-2"></i>Dodaj prvo tekmovanje
    </button>
  </div>
</div>